<script setup lang="ts">
import type { EditorialGridModuleProps } from './EditorialGridModule.props'
import UILink from '@design-system/components/UI/Link/UILink.vue'

defineProps<EditorialGridModuleProps>()
</script>

<template>
  <div class="grid grid-cols-2 gap-0.5 md:grid-cols-3">
    <div
      v-for="(item, index) in gridModule"
      :key="index"
      class="aspect-1/1 relative overflow-hidden text-center"
      :class="[
        item.backgroundColor && `bg-editorial-${item?.backgroundColor}`,
        item.textColor && `text-editorial-${item?.textColor}`,
      ]"
    >
      <component :is="item.linkCard ? UILink : 'div'" v-bind="item.linkCard">
        <!-- Media -->
        <UIMedia
          v-if="item?.media"
          v-bind="item?.media"
          aspect-ratio="1/1"
          class="h-full w-full object-cover"
        />
        <!-- Quote -->
        <UtilsMarkdown
          v-if="item.quote"
          :content="item.quote"
          is-preprocessed
          container="span"
          class="text-light-6 absolute left-1/2 top-1/2 w-full -translate-x-1/2 -translate-y-1/2 p-5 lg:p-7"
        />
        <!-- Text -->
        <UtilsMarkdown
          v-else-if="item.text"
          :content="item.text"
          is-preprocessed
          container="span"
          class="text-book-7 md:text-book-5 lg:text-book-4 absolute left-1/2 top-1/2 w-full -translate-x-1/2 -translate-y-1/2 p-5 lg:p-7"
        />

        <!-- Links -->
        <div
          v-if="item.links && item.links.length > 0"
          class="absolute left-1/2 top-1/2 grid w-full -translate-x-1/2 -translate-y-1/2 justify-center gap-4 p-5 md:flex md:gap-6 lg:gap-12 lg:p-7"
        >
          <UILink v-for="link in item.links" :key="link.label" v-bind="link" />
        </div>
      </component>
    </div>
  </div>
</template>
